import { Observable, throwError } from 'rxjs';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient ,HttpErrorResponse, HttpHeaders} from '@angular/common/http';

import { DashboardConfigManager } from './dashboard.config.service';
import { LogService } from '../logger/loggerProvider/loggerhelper.service';
import { catchError, map, mapTo } from 'rxjs/operators';

interface External {
    GetToken: Function;
}

@Injectable()
export class AuthService {

    private hasToken: boolean = false;
    wsiURL: string
    token: any;
    tokenKey: string = "_token";

    constructor(private http: HttpClient, private dashboardConfig: DashboardConfigManager, private logger: LogService) {
        this.wsiURL = "http://localhost:8080";
        this.init();
    }

    public Login(username: string, password: string, wsiurlLocal: string): any {
        this.logger.logInfo("AuthService", "Received login request!");
        this.wsiURL = wsiurlLocal;
        let body = "grant_type=password&username=" + username + "&password=" + password;
        let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        //let options = new RequestOptions({ headers: headers });

        return this.http.post(this.wsiURL + "/api/token", body, { headers: headers })
            .pipe(map(res => {
                if (res) {
                    
                    var result = res as any;
                    var response=result;
                
                  
                    this.token = response;
                    console.log("Token"+this.token);
                    window.sessionStorage.setItem(this.tokenKey, this.token.access_token);
                    this.hasToken = true
                    return true;
                    
                  
                } else {
                    this.hasToken = false;
                    return false;
                }
            }),catchError((error) =>
                {
                    let errMsg = (error.message) ? error.message :
                        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                    this.logger.logError("AuthService", "Error: " + errMsg);
                    return throwError(errMsg);
                }));
    }

    public LoginWithSSO(): any {
        this.logger.logInfo("AuthService", "Login Called!");
        this.wsiURL = this.dashboardConfig.getBaseUrl();
        let ssoToken = window.sessionStorage.getItem('SSO');
        let body = "grant_type=client_credentials&Client_Id=" + ssoToken;
        let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
        //let options = new RequestOptions({ headers: headers });
        return this.http.post(this.wsiURL + "/api/token", body, { headers: headers }).pipe(map(res => {
            if (res) {
                var result = res as any;
                this.token = result;
                console.log("Token"+this.token);
                window.sessionStorage.setItem(this.tokenKey, this.token.access_token);
                this.hasToken = true;
                return true;
            } else {
                this.hasToken = false;
                return false;
            }
        }),catchError((error) =>
                {
                    let errMsg = (error.message) ? error.message :
                        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                    this.logger.logError("AuthService", "Error: " + errMsg);
                    return throwError(errMsg);
                }));
    }

    getSessionData(key: string): string {
        let result = window.sessionStorage.getItem(key);
        if (result) {
            //  this.logger.logInfo("AuthService","Key value Found in sessionStorage!");
            return result;
        }
        else
            return undefined;
    }

    getToken(): String {
        return window.sessionStorage.getItem(this.tokenKey);
    }

    HasValidToken(): boolean {
        let sso = window.sessionStorage.getItem(this.tokenKey);
        if (sso) {
            return true;
        }
        return false;
    }

    HasValidSSO(): boolean {
        let sso = window.sessionStorage.getItem('SSO');
        if (sso) {
            return true;
        }
        return false;
    }

    init() {
        //this.logger.logInfo("AuthService","Login: onInit");

        if (typeof window.external !== "undefined") {
            try {
                var result = (window.external as unknown as External);

                if (typeof result !== "undefined" && typeof result.GetToken !== "undefined") {
                    let privateData = result.GetToken();
                    window.sessionStorage.removeItem('SSO');
                    window.sessionStorage.removeItem(this.tokenKey);
                    let splitted = privateData.split("\n");
                    if (splitted) {
                        for (let i = 0; i < splitted.length; i++) {
                            let keyValue = splitted[i].split(':', 2);
                            if ((typeof keyValue[0] !== "undefined") && (typeof keyValue[1] !== "undefined")) {
                                window.sessionStorage.setItem(keyValue[0], keyValue[1]);
                            }
                        }
                    }
                }
            }
            catch (err) {
                this.hasToken = false;
                //this.logger.logError("AuthService","Error while login. Error: " + err);
            }
        }
    }

    private handleError(error: any) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        this.logger.logError("AuthService", "Error: " + errMsg);
        return throwError(errMsg);
    }

}